import React, { Component } from 'react'
import { Route, Redirect } from 'react-router-dom'
import ApiService from '../../ApiService';

class AuthenticatedRoute extends Component {
    render() {

        if (ApiService.isUserLoggedIn()) {
            return <Route {...this.props} />
        } else {
            return <Redirect to="/login" />
        }

    }
}

export default AuthenticatedRoute